import { Component, ViewChild } from '@angular/core';
import { FormPanelConfigBuilder } from '../builders/form-panel-config.builder';
import { exampleFormConfig, examplePageFormConfig } from './example-page.config';
import { EoFormComponent, EoInputConfig } from 'ngx-eo-web-components';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-example-page',
  templateUrl: './example-page.component.html',
  styleUrl: './example-page.component.scss'
})
export class ExamplePageComponent {
  @ViewChild('eoFormContactForm', { static: false })
  eoFormContactForm!: EoFormComponent;

  examplePageFormConfig = examplePageFormConfig;

  private builder: FormPanelConfigBuilder;

  constructor(

  ) {
    const options = {
      header: 'Παραδειγμα με πεδια',
      headerStyleClass: 'p-panel-title',
      styleClass: 'container',
      panelStyleClass: 'grid',
    };
    this.builder = new FormPanelConfigBuilder(
      'contactFormConfig',
      this.examplePageFormConfig[0].config,
      options
    );
  }

  ngOnInit() {
    this.builder.getControl('region')?.valueChanges.subscribe(region => {
      let options: any[] = [];
      if (region === 'europe') {
        options = [
          { label: '+30 Ελλάδα', value: '+30' },
          { label: '+44 UK', value: '+44' },
        ];
      } else if (region === 'america') {
        options = [
          { label: '+1 USA', value: '+1' },
        ];
      }
      this.builder.updateFieldOptions('phone', options);
      this.builder.add(

          new EoInputConfig({
                name: 'name22',
                label: 'Μολις Μπηκα στη θεση 2',
                styleClass: 'col-12',
                control: new FormControl('', [Validators.required]),
                placeholder: 'Παρακαλώ συμπληρώστε Όνομα',
                errors: { required: 'Υποχρεωτικό πεδίο' },
              })
        , 2
      );

      this.builder.remove('surname');

      this.rebuildForm();
    });

    this.rebuildForm();
  }

  private rebuildForm() {
    this.examplePageFormConfig = [this.builder.build()];
  }
}
